import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_MAILBOX } from "../mailbox.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateMailboxInput } from "../../../__generated__/globalTypes";
import {
  CreateMailboxMutation,
  CreateMailboxMutationVariables,
} from "../../../__generated__/CreateMailboxMutation";

interface IProps {
  defaultValues: DeepPartial<CreateMailboxInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreateMailbox = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateMailboxInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateMailboxMutation,
    CreateMailboxMutationVariables
  >(CREATE_MAILBOX, {
    refetchQueries: ["MyMailboxQuery"],
    update(cache) {
      evictFields(cache, ["myMailbox"]);
    },
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createMailbox?.ok) {
        toast.success("Boite mail connectée avec succès");
        onCompleted(data.createMailbox.id);
      } else {
        throw Error(data?.createMailbox?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
